import { RightOutlined } from '@ant-design/icons';
import classNames from 'classnames';
import React from 'react';
import { OmniaButton } from '../../../omnia_button/omnia_button';
import SvgLockIcon from '../../../svg/lock_icon';
import {
  LayerInfo,
  POINTS_OF_INTEREST_LAYER,
  POINTS_OF_INTEREST_LAYER_INFO,
  WEATHER_LAYER,
  WEATHER_LAYER_INFO,
} from '../../map_types';
import styles from './layer_card.less';
import { LayerCardButton } from './layer_card_button';

interface LayerCardProps {
  checked: boolean;
  isLocked?: boolean;
  layer: LayerInfo;
  onDetailsClick?: () => void;
  onSelect: () => void;
  otherDetailsHtml?: React.ReactNode;
  showDetailsButton?: boolean;
  useButton?: boolean;
}

export const LayerCard = (props: LayerCardProps) => {
  const {
    checked,
    isLocked,
    layer,
    onDetailsClick,
    onSelect,
    otherDetailsHtml,
    showDetailsButton = true,
    useButton,
  } = props;

  const {
    icon,
    imgSrc,
    name,
    // value
  } = layer;
  const Icon = icon;
  const isCmapLayer = name.startsWith('C-MAP');
  const isWindLayer = name === WEATHER_LAYER_INFO[WEATHER_LAYER.WIND].name;
  const isWaypointsLayer =
    name === POINTS_OF_INTEREST_LAYER_INFO[POINTS_OF_INTEREST_LAYER.WAYPOINTS].name;
  // const isWaterTempRealTimeLayer = value === CORE_LAYER.WATER_TEMP_REAL_TIME;
  const isWaterTempRealTimeLayer = false;

  return (
    <div className={styles.card}>
      <div className="flex items-center ">
        <span
          className={classNames(styles.layerIcon, 'relative min-w-12', {
            [styles.icon__wind]: isWindLayer,
          })}
        >
          <img src={imgSrc} alt="" className={'rounded-lg'} />
          <span className="w-8 h-8 bg-[#11181C] rounded-full p-[.3rem] flex items-center justify-center absolute">
            <Icon color={'#657D7D'} className="w-6" />
          </span>
        </span>
        <span className={styles.cardInfo}>
          <span id={`${name}InputDescription`} className={styles.layerName}>
            {name}
          </span>
          {isCmapLayer && <span className={styles.cmapTag}>Community Powered</span>}
          <div className={styles.infoLineTwo}>
            {otherDetailsHtml && <div className={styles.otherDetails}>{otherDetailsHtml}</div>}
          </div>
        </span>

        {isWaypointsLayer && isLocked ? (
          <span className={styles.lockIcon}>
            <SvgLockIcon />
          </span>
        ) : (
          <LayerCardButton
            useButton={useButton}
            checked={checked}
            layer={layer}
            onSelect={onSelect}
            isLocked={isLocked}
            isComingSoon={isWaterTempRealTimeLayer}
          />
        )}
      </div>
      {showDetailsButton && (
        <span
          className={classNames('flex justify-between', styles.rowTwo)}
          onClick={onDetailsClick}
        >
          <>
            <OmniaButton
              size="md"
              kind="text"
              className={styles.detailsButton}
              onPress={onDetailsClick}
              aria-label={`More Information about ${name} layer`}
            >
              View Details
            </OmniaButton>
            <RightOutlined className="mr-3" />
          </>
        </span>
      )}
    </div>
  );
};
